(function (window) {
    var Date = window.Date;
    var setTimeout = window.setTimeout;
    var clearTimeout = window.clearTimeout;
    
    function Timer(delay, callback) {
        var timer, start, remaining = delay;
        
        this.clear = function () {
            clearTimeout(timer);
            remaining = delay;
        };
        
        this.pause = function () {
            clearTimeout(timer);
            remaining -= new Date() - start;
        };
        
        this.play = function () {
            this.clear();
            
            start = new Date();
            timer = setTimeout(callback, remaining);
        };
    }
    
    function RecurringTimer(interval, callback) {
        var timer,
            start,
            _this = this,
            remaining = interval;
        
        this.clear = function () {
            clearTimeout(timer);
            remaining = interval;
        };
        
        this.pause = function () {
            clearTimeout(timer);
            remaining -= new Date() - start;
        };
        
        this.play = function () {
            clearTimeout(timer);
            
            start = new Date();
            timer = setTimeout(function () {
                remaining = interval;
                
                callback();
                _this.play();
            }, remaining);
        };
    }
    
    window.Timer = Timer;
    window.RecurringTimer = RecurringTimer;
})(window);
